import {
    FileAddOutlined,
    BarChartOutlined,
    LogoutOutlined,
} from "@ant-design/icons";

export const menuItems = [
    {
        key: "/logsheet/dashboard",
        icon: <BarChartOutlined />,
        label: "Dashboard",
        path: "/logsheet/dashboard",
    }, {
        key: "/logsheet/log-entry",
        icon: <FileAddOutlined />,
        label: "Log Sheet",
        path: "/worksheet/log-entry",
    },
    {
        key: "/logsheet/reports",
        icon: <BarChartOutlined />,
        label: "Reports",
        path: "/logsheet/reports",
    },
    {
        key: "logout",
        icon: <LogoutOutlined />,
        label: "Logout",
    }
];

export const ROLES = {
    SPEND_TEAM: 'Spend team',
    ACCOUNT_TEAM: 'Account team',
    PLANT_HOD: 'Plant HOD',
    PLANT_USER: 'Plant user',
    OWNER: 'Owner',
};

export const GOOGLE_MAPS_BASE_URLS = {
    PLACE: 'https://www.google.com/maps',
    DIRECTIONS: 'https://www.google.com/maps/dir/',
};

export const USER_ROLE_OPTIONS = [
    { value: ROLES.PLANT_HOD, label: 'Plant HOD' },
    { value: ROLES.PLANT_USER, label: 'Plant User' },
    { value: ROLES.ACCOUNT_TEAM, label: 'Account Team' },
    { value: ROLES.OWNER, label: 'Owner' },
]

export const EQUIPMENT_TYPE_OPTIONS = [
    { value: 'Movable Equipment - Light vehicle', label: 'Movable Equipment - Light vehicle' },
    { value: 'Movable Equipment - Heavy vehicle', label: 'Movable Equipment - Heavy vehicle' },
    { value: 'Non-Movable Equipment', label: 'Non-Movable Equipment' },
];

export const FUEL_TYPE_OPTIONS = [
    { value: 'Diesel', label: 'Diesel' },
    { value: 'Petrol', label: 'Petrol' },
    { value: 'Electric', label: 'Electric' },
]

export const BILLING_CYCLE_OPTIONS = [
    { value: 'Monthly Billing', label: 'Monthly Billing' },
    { value: 'Adhoc Billing', label: 'Adhoc Billing' }
]

export const UNIT_OF_MEASURE_OPTIONS = [
    { value: 'Hourly', label: 'Hourly' },
    { value: 'Daily', label: 'Daily' },
    { value: 'Monthly', label: 'Monthly' }
]

export const EQUIPMENT_BASE_COLUMNS = [
    { title: 'Vehicle No', dataIndex: 'vehicle_no', key: 'vehicle_no', width: 120, fixed: 'left' },
    { title: 'Equipment Type', dataIndex: 'equipment_type', key: 'equipment_type', width: 140 },
    { title: 'Equipment Name', dataIndex: 'equipment_name', key: 'equipment_name', width: 150 },
    { title: 'Fuel Type', dataIndex: 'fuel_type', key: 'fuel_type', width: 100 },
    // { title: 'Manufacturer', dataIndex: 'manufacturer', key: 'manufacturer', width: 130 },
    // { title: 'Mfg. Year', dataIndex: 'manufacturing_year', key: 'manufacturing_year', width: 100 },
    { title: 'GPS IMEI No', dataIndex: 'gps_imei_no', key: 'gps_imei_no', width: 140 },
    { title: 'Deployment Area', dataIndex: 'deployment_area', key: 'deployment_area', width: 140 },
    { title: 'Plant Name', dataIndex: 'plant_name', key: 'plant_name', width: 130 },
    { title: 'Plant User', dataIndex: 'plant_user', key: 'plant_user', width: 130 },
    { title: 'Plant HOD', dataIndex: 'plant_hod', key: 'plant_hod', width: 130 },
    // { title: 'Cost Center', dataIndex: 'cost_center', key: 'cost_center', width: 120 },
    // { title: 'Owner Email', dataIndex: 'owner_email', key: 'owner_email', width: 180 },
    // { title: 'Driver Mobile', dataIndex: 'driver_mobile_no', key: 'driver_mobile_no', width: 130 },
    { title: 'AMNS WO', dataIndex: 'amns_wo', key: 'amns_wo', width: 120 },
    { title: 'Billing Period', dataIndex: 'billing_cycle', key: 'billing_cycle', width: 120 },
    { title: 'Contract Rate', dataIndex: 'contract_rate', key: 'contract_rate', width: 120 },
    // { title: 'Service Start Time', dataIndex: 'service_start_time', key: 'service_start_time', width: 130 },
    // { title: 'Service End Time', dataIndex: 'service_end_time', key: 'service_end_time', width: 130 },
    { title: 'Last Location Date', dataIndex: 'last_location_date', key: 'last_location_date', width: 150 },
    { title: 'Last Location Time', dataIndex: 'last_location_time', key: 'last_location_time', width: 150 },
    { title: 'Last Location Fetched At', dataIndex: 'last_location_fetched_at', key: 'last_location_fetched_at', width: 180 },
];

export const USER_BASE_COLUMNS = [
    { title: 'Email', dataIndex: 'email', key: 'email', width: '22%' },
    { title: 'Full Name', dataIndex: 'full_name', key: 'full_name', width: '22%' },
    { title: 'Role', dataIndex: 'role', key: 'role', width: '22%' },
    { title: 'Plant HOD', dataIndex: 'plant_hod', key: 'plant_hod', width: '22%' },
];

export const REPORT_TYPE_OPTIONS = [
    { value: 'vehicle', label: 'Vehicle Report' },
];

export const vehicleReportColumns = [
    { title: 'Date', dataIndex: 'Date', key: 'Date', width: 110 },
    { title: 'Vehicle No', dataIndex: 'Vehicle No', key: 'Vehicle No', width: 130 },
    { title: 'Start Time', dataIndex: 'Start Time', key: 'Start Time', width: 110 },
    { title: 'End Time', dataIndex: 'End Time', key: 'End Time', width: 110 },
    { title: 'Total Hours', dataIndex: 'Total Hours', key: 'Total Hours', width: 110 },
    {
        title: 'Running Km',
        dataIndex: 'Running Km',
        key: 'Running Km',
        width: 120,
        render: (value) =>
            value === null || value === undefined || value === ''
                ? value
                : `${value} kms`,
    },
    { title: 'User Remarks', dataIndex: 'User Remarks', key: 'User Remarks', width: 180 },
    { title: 'Owner Remarks', dataIndex: 'Owner Remarks', key: 'Owner Remarks', width: 180 },
];
